import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import fetchResourceById from 'components/hoc/fetchResourceById';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Loader from 'components/loading/Loader';
import AccessMethodsEdit from './AccessMethodEdit';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchAccessPoint } from 'store/actions/accessPoints/fetchAccessPoints';
import { fetchAccessPointAccessMethods } from 'store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { updateAccessPointAccessMethod } from 'store/actions/accessPoints/access-methods/edit/updateAccessPointAccessMethod';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';

class AccessMethodEditContainer extends React.Component {
    componentDidMount() {
        const {
            fetchAccessMethods,
            id,
            method,
        } = this.props;

        if (utils.isEmpty(method)) {
            fetchAccessMethods({
                access_point_id: id,
            });
        }

        if (this.props.productId) {
            const { fetchAccessPointProduct, productId } = this.props;

            fetchAccessPointProduct(productId);
        }
    }

    handleSubmit = (values) => {
        const {
            data,
            history,
            method: {
                id,
            },
            updateAccessMethod,
        } = this.props;

        return new Promise((resolve) => {
            updateAccessMethod({
                id: id,
                onError: () => {
                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ data.product_id }/access-points/${ data.id }/show`));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            data,
            id: accessPointId,
            loading,
            method,
            product,
            resource,
            translate,
        } = this.props;

        if (loading) {
            return <Loader />;
        }

        if (!data || !method) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [];

        if (product) {
            breadcrumbs.push(
                {
                    label: translate('resources.products.title'),
                    link: `/products`,
                },
                {
                    label: product.title,
                    link: `/products/${ product.id }/show`,
                },
                {
                    label: translate('resources.access_points.title'),
                },
                {
                    label: data.title,
                    link: `/products/${ product.id }/${ resource }/${ accessPointId }/show`,
                },
                {
                    label: translate('resources.access_methods.title'),
                },
                {
                    label: translate(`resources.access_methods.list.directions.${ method.access_direction }`),
                },
                {
                    label: translate('actions.edit'),
                },
            );
        }

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title
                        title={ translate('resources.access_methods.edit.title') }
                    />

                    {
                        product &&
                        <Actions>
                            <ListButton
                                url={ `/products/${ product.id }/${ resource }/${ accessPointId }/show` }
                            />
                        </Actions>
                    }
                </Header>

                <Card>
                    <CardText>
                        <AccessMethodsEdit
                            { ...this.props }
                            form='access-method_edit'
                            initialValues={ this.props.method }
                            handleSubmitForm={ this.handleSubmit }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

AccessMethodEditContainer.propTypes = {
    accessMethodId: PropTypes.number.isRequired,
    data: PropTypes.shape({
        id: PropTypes.number,
        product_id: PropTypes.string,
        title: PropTypes.string,
    }),
    fetchAccessMethods: PropTypes.func,
    fetchAccessPointProduct: PropTypes.func,
    history: PropTypes.object,
    id: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    method: PropTypes.object,
    product: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }),
    productId: PropTypes.string,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateAccessMethod: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    const {
        accessMethodId,
        subResource,
    } = props;

    const { data, loading } = state[subResource];

    const method = utils.find(data, (method) => {
        return method.id === accessMethodId;
    });

    const additionalProps = {};

    if (props.productId) {
        const { productId } = props;

        additionalProps.product = state.products.data[productId] || null;
    }

    return {
        method: method,
        loading: loading,
        ...additionalProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAccessMethods: (payload) => {
            dispatch(fetchAccessPointAccessMethods(payload));
        },
        fetchAccessPointProduct: (id) => {
            dispatch(fetchProduct({
                id: id,
            }));
        },
        updateAccessMethod: (payload) => {
            dispatch(updateAccessPointAccessMethod(payload));
        },
    };
};
const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchAccessPoint,
        resource: 'access-points',
    })
);

export default enhance(AccessMethodEditContainer);



// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/edit/AccessMethodEditContainer.js